import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
    /** default: the 1080px content column. wide: 1392px (blog). narrow: 680px (articles, legal). */
    size?: 'default' | 'wide' | 'narrow'
}

export const Container: FC<ContainerProps> = ({ children, className, size = 'default' }): ReactNode => {
    return (
        <div
            className={cn(
                'mx-auto w-full',
                size === 'default' && 'section-x max-w-[calc(1080px+2*clamp(16px,3vw,32px))]',
                size === 'wide' && 'max-w-[1392px] px-4 sm:px-6',
                size === 'narrow' && 'section-x max-w-[calc(680px+2*clamp(16px,3vw,32px))]',
                className
            )}
        >
            {children}
        </div>
    )
}
